module.exports = __webpack_public_path__ + "assets/img/VVVIP.f8869e8f.png";